import { Delegate } from './delegate.js';

if (!customElements.get('save-with-kits-cards')) {
  customElements.define(
    'save-with-kits-cards',
    class SaveWithKitsCards extends HTMLElement {
      connectedCallback() {
        this.delegate = new Delegate(this);
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
          this.init();
        });
      }

      disconnectedCallback() {
        this.delegate?.destroy();
        this.delegate = null;
        cancelAnimationFrame(this._raf);
        this.destroy();
      }

      init() {
        if (typeof FoxTheme === 'undefined' || !FoxTheme.Carousel) {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = null;
            if (this.isConnected) this.init();
          });
          return;
        }

        const wrap = this.querySelector('.product__save-with-kits-swiper');
        const track = this.querySelector('.product__save-with-kits-track');
        if (!wrap || !track) return;

        const slideCount = track.querySelectorAll('.swiper-slide').length;
        if (slideCount === 0) return;

        if (this.carousel?.slider) {
          return;
        }

        wrap.classList.add('swiper', 'swiper-equal-height', 'overflow-visible');
        track.classList.add('swiper-wrapper');
        track.classList.remove('f-grid');

        const sliderOptions = this.parseSliderOptions();
        const peekSettings = sliderOptions.peek || {};
        delete sliderOptions.peek;

        const measuredWidth = Math.round(wrap.getBoundingClientRect().width || wrap.clientWidth || 300);
        const containerWidth = Math.max(measuredWidth, 200);
        const isMobile = window.matchMedia('(max-width: 767.98px)').matches; // matchMedia: legacy theme has no responsive utility module.
        const gap = isMobile ? (peekSettings.mobileGap ?? 12) : (peekSettings.desktopGap ?? 8);
        const peek = isMobile ? (peekSettings.mobilePeek ?? 41) : (peekSettings.desktopPeek ?? 38);

        /**
         * A card fills the track minus the gap and the sliver of the next card that stays
         * visible. Swiper sizes slides as (width - (spv - 1) * gap) / spv, so inverting that
         * for the wanted card width gives slidesPerView = (width + gap) / (card + gap).
         */
        const slideWidth = Math.max(160, containerWidth - peek - gap);
        const slidesPerView = slideCount > 1 ? (containerWidth + gap) / (slideWidth + gap) : 1;
        const opts = {
          ...sliderOptions,
          spaceBetween: gap,
          slidesPerView,
        };

        const navigation = sliderOptions.navigation;
        if (slideCount > 1 && navigation) {
          opts.navigation = {
            ...navigation,
            prevEl: this.querySelector(navigation.prevEl),
            nextEl: this.querySelector(navigation.nextEl),
          };
        } else {
          opts.navigation = false;
        }

        this.carousel = new window.FoxTheme.Carousel(wrap, opts, [FoxTheme.Swiper.Mousewheel]);
        this.carousel.init();
      }

      /** Parses the Liquid-authored slider config from the HTML data attribute. */
      parseSliderOptions() {
        try {
          return JSON.parse(this.dataset.sliderOptions || '{}');
        } catch (error) {
          return {};
        }
      }

      destroy() {
        if (typeof this.carousel !== 'object' || !this.carousel?.slider) return;
        try {
          this.carousel.slider.destroy(true, true);
        } catch (_) {
          /* noop */
        }
        this.carousel = null;

        const wrap = this.querySelector('.product__save-with-kits-swiper');
        const track = this.querySelector('.product__save-with-kits-track');
        if (wrap) {
          wrap.classList.remove('swiper', 'swiper-equal-height', 'overflow-visible');
        }
        if (track) {
          track.classList.remove('swiper-wrapper');
          track.classList.add('f-grid', 'f-grid--gap-2xs');
        }
      }
    }
  );
}
